import * as React from "react";
import { cn } from "../../lib/cn";

export interface InputProps extends React.ComponentProps<"input"> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, hint, id, ...props }, ref) => {
    const inputId = id ?? props.name;

    return (
      <div className="w-full space-y-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-xs font-bold text-[var(--gv-ink)]"
          >
            {label}
          </label>
        )}
        <input
          id={inputId}
          ref={ref}
          className={cn(
            "admin-input flex h-9 w-full rounded-xl border border-[var(--gv-border)] bg-white px-3.5 py-2 text-xs text-[var(--gv-ink)] placeholder:text-[var(--gv-ink-muted)] focus-visible:outline-none focus-visible:border-[var(--gv-brand)] disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-rose-400 focus-visible:border-rose-500",
            className
          )}
          {...props}
        />
        {error ? (
          <p className="text-[10px] font-semibold text-rose-600">{error}</p>
        ) : hint ? (
          <p className="text-[10px] text-[var(--gv-ink-muted)]">{hint}</p>
        ) : null}
      </div>
    );
  }
);

Input.displayName = "Input";
